<!-- 手势插件 https://github.com/AlloyTeam/AlloyFinger -->
<template>
  <div ref="wrap">
    <slot></slot>
  </div>
</template>

<script>
  import AlloyFinger from 'alloyfinger'
  export default {
    data () {
      return {}
    },

    mounted () {
      let _this = this
      let af = new AlloyFinger(this.$refs.wrap, {})
      af.on('swipe', function (e) {
        // direction: Left or Right
        _this.$emit('swipe', e.direction, e)
      }),
      af.on('touchMove', function (e) {
        _this.$emit('touchMove', e)
      }),
      af.on('touchEnd', function (e) {
        _this.$emit('touchEnd', e)
      })
      af.on('doubleTap', function (e) {
        _this.$emit('doubleTap', e)
      })
      af.on('pinch', function (e) {
        _this.$emit('pinch', e)
      })
    }
  }
</script>

<style scoped>
  
</style>


// WEBPACK FOOTER //
// src/components/KktGesture.vue